/**
 * A class describes a column and direction, in which table should be sorted.
 */
export class TableSort {
  column: string;
  direction: SortDirection;

  /**
   * @param column a column, by which the table should be sorted.
   * @param direction a direction, to which the table should be sorted.
   */
  constructor(column: string, direction: SortDirection) {
    this.column = column;
    this.direction = direction;
  }
}

/**
 * An enumeration of possible table sorting directions.
 */
export enum SortDirection {
  /** The table should be sorted in ascending order by the given column. */
  ASC = 'asc',
  /** The table should be sorted in descending order by the given column. */
  DESC = 'desc',
  /** The table should return to an original order by the given column. */
  NONE = ''
}

